import React from 'react';
import { Card, CardContent } from '../../../../components/card';
import { Input } from '../../../../components/input';
import { Label } from '../../../../components/label';
import { SocialMediaUIState } from '../BusinessProfile.data';
import FacebookIcon from '../../../../assets/icons/facebook-icon-gray.svg';
import InstagramIcon from '../../../../assets/icons/instagram-icon-gray.svg';
import LinkedInIcon from '../../../../assets/icons/linkedin-icon-gray.svg';
import TikTokIcon from '../../../../assets/icons/tiktok-icon-gray.svg';

interface SocialMediaSectionProps {
    socialMedia: SocialMediaUIState;
    onSocialMediaChange: (field: keyof SocialMediaUIState, value: string) => void;
}

export const SocialMediaSection: React.FC<SocialMediaSectionProps> = ({
    socialMedia,
    onSocialMediaChange,
}) => {
    return (
        <Card className="border border-[#e2e8f0] dark:border-gray-700 bg-white dark:bg-gray-800 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] dark:shadow-[0px_1px_2px_0px_rgba(0,0,0,0.3)] rounded-[8px]">
            <CardContent className="px-[24px] py-[24.8px]">
                <h2 className="text-[24px] font-semibold text-[#020817] dark:text-white tracking-[-0.6px] mb-0">
                    Social Media Links
                </h2>

                <div className="pt-[5px] pb-0 h-[289px]">
                    <div className="flex flex-col gap-4">
                        {/* First Row */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-[13px]">
                            <Label htmlFor="facebook" className="text-[14px] font-medium text-[#020817] dark:text-gray-200">
                                Facebook
                            </Label>
                            <div className="relative">
                                <div className="absolute left-[12.8px] top-1/2 -translate-y-1/2 z-10 pointer-events-none">
                                    <img src={FacebookIcon} alt="Facebook" className="w-5 h-5 dark:opacity-80" />
                                </div>
                                <Input
                                    id="facebook"
                                    value={socialMedia.facebook}
                                    onChange={(e) => onSocialMediaChange('facebook', e.target.value)}
                                    className="h-[40px] border border-[#e2e8f0] dark:border-gray-700 rounded-[6px] px-[12.8px] py-[10.4px] pl-[40px] text-[14px] bg-white dark:bg-gray-900 text-foreground"
                                    placeholder="Enter Facebook URL"
                                />
                            </div>
                        </div>

                        <div className="space-y-[13px]">
                            <Label htmlFor="instagram" className="text-[14px] font-medium text-[#020817] dark:text-gray-200">
                                Instagram
                            </Label>
                            <div className="relative">
                                <div className="absolute left-[12.8px] top-1/2 -translate-y-1/2 z-10 pointer-events-none">
                                    <img src={InstagramIcon} alt="Instagram" className="w-5 h-5 dark:opacity-80" />
                                </div>
                                <Input
                                    id="instagram"
                                    value={socialMedia.instagram}
                                    onChange={(e) => onSocialMediaChange('instagram', e.target.value)}
                                    className="h-[40px] border border-[#e2e8f0] dark:border-gray-700 rounded-[6px] px-[12.8px] py-[10.4px] pl-[40px] text-[14px] bg-white dark:bg-gray-900 text-foreground"
                                    placeholder="Enter Instagram URL"
                                />
                            </div>
                        </div>
                    </div>

                        {/* Second Row */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-[13px]">
                            <Label htmlFor="linkedin" className="text-[14px] font-medium text-[#020817] dark:text-gray-200">
                                LinkedIn
                            </Label>
                            <div className="relative">
                                <div className="absolute left-[12.8px] top-1/2 -translate-y-1/2 z-10 pointer-events-none">
                                    <img src={LinkedInIcon} alt="LinkedIn" className="w-5 h-5 dark:opacity-80" />
                                </div>
                                <Input
                                    id="linkedin"
                                    value={socialMedia.linkedin}
                                    onChange={(e) => onSocialMediaChange('linkedin', e.target.value)}
                                    className="h-[40px] border border-[#e2e8f0] dark:border-gray-700 rounded-[6px] px-[12.8px] py-[10.4px] pl-[40px] text-[14px] bg-white dark:bg-gray-900 text-foreground"
                                    placeholder="Enter LinkedIn URL"
                                />
                            </div>
                        </div>

                        <div className="space-y-[13px]">
                            <Label htmlFor="tiktok" className="text-[14px] font-medium text-[#020817] dark:text-gray-200">
                                Tiktok
                            </Label>
                            <div className="relative">
                                <div className="absolute left-[12.8px] top-1/2 -translate-y-1/2 z-10 pointer-events-none">
                                    <img src={TikTokIcon} alt="TikTok" className="w-5 h-5 dark:opacity-80" />
                                </div>
                                <Input
                                    id="tiktok"
                                    value={socialMedia.tiktok}
                                    onChange={(e) => onSocialMediaChange('tiktok', e.target.value)}
                                    className="h-[40px] border border-[#e2e8f0] dark:border-gray-700 rounded-[6px] px-[12.8px] py-[10.4px] pl-[40px] text-[14px] bg-white dark:bg-gray-900 text-foreground"
                                    placeholder="Enter TikTok URL"
                                />
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

